import { RULE_AREAS, type RuleArea } from "@unbox/api";
import { Package, Tag01, UserX01 } from "@untitledui/icons";

export type RuleAreaDetails = {
  label: string;
  description: string;
  icon: typeof Tag01;
};

export const RULE_AREA_DETAILS: Record<RuleArea, RuleAreaDetails> = {
  cohort: {
    label: "Cohorts",
    description: "Group creators into a cohort as soon as their numbers say so.",
    icon: Tag01,
  },
  sample: {
    label: "Samples",
    description: "Approve or reject sample requests without reading every one.",
    icon: Package,
  },
  blocklist: {
    label: "Blocked creators",
    description: "Keep the creators you don't want to work with out of your campaigns.",
    icon: UserX01,
  },
};

export const RULE_AREA_ORDER: RuleArea[] = [...RULE_AREAS];
